import React from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text3, Text4 } from "../../../styles";
import { Descriptions, Badge, Tooltip, Icon } from "antd";
import { printRupee } from "../../../app_methods";
import { TRANSFER_STATUS_TYPES, SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES, SMART_COLLECT_TRANSACTION_ORDERS_NOTIFICATION_CYCLE_TYPES, VENDOR_INVOICE_STATUS_TYPES, COMPARISON_VALIDITY_STATUS, PAYMENT_MODES } from "../../../constants";
// import { SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES, SMART_COLLECT_TRANSACTION_ORDERS_NOTIFICATION_CYCLE_TYPES } from "../../SmartCollect/constants";
import moment from 'moment';
import { isEmpty } from "lodash";

import { beneficiaryOrganisationTypes } from "../../../constants";


const RecordDetailsDrawer = (props) => {
    const batch_record = props.batch_record || {};
    const record_params = batch_record.record_params || {};
    const record = batch_record.record || {};
    const record_response = batch_record.record_response || {};
    const threshold_percentage = record_params.threshold_percentage ? record_params.threshold_percentage : props.threshold_percentage


    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Record Details</Text1>
            </div>
        )
    };

    const renderComparisonValiditywithTooltip = () => {
        return (
          <div className="d-flex align-items-center">
            Comparison Validity
            <Tooltip title={`Comparison percentage must be at least ${threshold_percentage}% to be successful`}>
              <Icon style={{color: "#1890ff"}} className="ml-2" type="exclamation-circle" />
            </Tooltip>
          </div>
        );
    };
    
    const renderAccountHolderNamewithTooltip = () => {
        return (
          <div className="d-flex align-items-center">
            Name Requested
            <Tooltip title="Account Holder Name to validate">
              <Icon style={{color: "#1890ff"}} className="ml-2" type="exclamation-circle" />
            </Tooltip>
          </div>
        );
    };
    
    const renderBankAccountHolderNamewithTooltip = () => {
        return (
          <div className="d-flex align-items-center">
            Account Holder Name
            <Tooltip title="Account Holder Name validated via Bank">
              <Icon style={{color: "#1890ff"}} className="ml-2" type="exclamation-circle" />
            </Tooltip>
          </div>
        );
    };

    const renderAdditionalDetails = () => {
        const isTransfer = batch_record.batch_type === "transfer";
        const hasFTxGamingDetails = !!record_params?.beneficiary_user_id || (
            !!record_params?.pan_number &&
            !record_params?.cin_number &&
            !record_params?.gst_number &&
            !record_params?.organisation_type &&
            !record_params?.business_model
        );
        const hasFTxDetails = !!record_params?.cin_number ||
            !!record_params?.gst_number ||
            !!record_params?.organisation_type ||
            !!record_params?.business_model ||
            (!!record_params?.pan_number &&
                !record_params?.beneficiary_user_id 
            );
        const isTransferorBeneficiary = ["beneficiary", "transfer"].includes(batch_record.batch_type)
        const isFTxBeneficiary = isTransferorBeneficiary && hasFTxDetails;
        const isFTxGamingBeneficiary = isTransferorBeneficiary && hasFTxGamingDetails;
    
        if (!isTransfer && !(isFTxBeneficiary || isFTxGamingBeneficiary)) return null;
    
        return (
            <>
                <Text3 className="d-block mb-2" strong>
                    Additional Details
                </Text3>
                <Descriptions className="mb-4" column={1} size="small" bordered>
                    {isTransfer && (
                        <>
                            <Descriptions.Item label="UDF 1">{record_params.udf1 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 2">{record_params.udf2 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 3">{record_params.udf3 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 4">{record_params.udf4 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 5">{record_params.udf5 || "---"}</Descriptions.Item>
                        </>
                    )}
                    {
                        (isFTxBeneficiary || isFTxGamingBeneficiary) && (
                            <>
                                <Descriptions.Item label="PAN Number">
                                    {record_params?.pan_number || "---"}
                                </Descriptions.Item> 
                            </>
                        )
                    }
                    {isFTxBeneficiary && (
                        <>
                            <Descriptions.Item label="CIN Number">
                                {record_params?.cin_number || "---"}
                            </Descriptions.Item>
                            <Descriptions.Item label="GST Number">
                                {record_params?.gst_number || "---"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Organisation Type">
                                {beneficiaryOrganisationTypes.find(x => x.value === record_params?.organisation_type)?.label || "---"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Business Model">
                                {record_params?.business_model || "---"}
                            </Descriptions.Item>
                        </>
                    )}
                    
                    {
                        isFTxGamingBeneficiary && (
                            <>
                                <Descriptions.Item label="Beneficiary User ID">
                                    {record_params?.beneficiary_user_id || "---"}
                                </Descriptions.Item>   
                            </>
                        )
                    }
                </Descriptions>
            </>
        );
    };
    

    const renderTransferDescriptions = () => {
        let is_amazon_transaction = record_params?.__payment_mode 
        return (
            <>
                <Descriptions.Item label="Beneficiary Name">{record_params.beneficiary_name || "---"}</Descriptions.Item>
                {
                    record_params.beneficiary_type == "upi" ?
                        <Descriptions.Item label="UPI Handle">{record_params.upi_handle || "---"}</Descriptions.Item>
                        :
                        <>
                            <Descriptions.Item label="Account Number">{record_params.account_number || "---"}</Descriptions.Item>
                            {record_params.beneficiary_type == "bank_account" ? <Descriptions.Item label="IFSC Code">{record_params.ifsc || "---"}</Descriptions.Item> : null}
                        </>
                }
                <Descriptions.Item label="Source Virtual Account">{record.source_virtual_account || "---"}</Descriptions.Item>
                <Descriptions.Item label="Unique Request Number">{record_params.unique_request_number || "---"}</Descriptions.Item>
                <Descriptions.Item label="Amount">{record_params.amount && printRupee(record_params.amount) || "---"}</Descriptions.Item>
                <Descriptions.Item label="UTR">{record.unique_transaction_reference || "---"}</Descriptions.Item>
                <Descriptions.Item label="Payment Mode">{ is_amazon_transaction ? PAYMENT_MODES[record_params.__payment_mode] :  PAYMENT_MODES[record_params.payment_mode] || "---"}</Descriptions.Item>
                <Descriptions.Item label="Narration">{record_params.narration || "---"}</Descriptions.Item>
                <Descriptions.Item label="Beneficiary Email ID">{record_params.beneficiary_email || "---"}</Descriptions.Item>
                <Descriptions.Item label="Beneficiary Phone">{record_params.beneficiary_phone || "---"}</Descriptions.Item>
                {record_params.scheduled_for ?
                    <Descriptions.Item label="Scheduled Date">{moment(record_params.scheduled_for).format("LL") || "---"}</Descriptions.Item>
                    : null}
                {
                    record.status ?
                        <Descriptions.Item label="Transfer Status"><Badge color={TRANSFER_STATUS_TYPES[record.status].color} text={TRANSFER_STATUS_TYPES[record.status].label} /></Descriptions.Item> : null
                }
            </>
        )
    };

    const renderBeneficiaryDescriptions = () => {
        return (
            <>
                <Descriptions.Item label="Beneficiary Name">{record_params.beneficiary_name || "---"}</Descriptions.Item>
                <Descriptions.Item label="Email">{record_params.email || "---"}</Descriptions.Item>
                <Descriptions.Item label="Phone Number">{record_params.phone || "---"}</Descriptions.Item>
                {
                    record_params.beneficiary_type == "upi" ?
                        <Descriptions.Item label="UPI Handle">{record_params.upi_handle || "---"}</Descriptions.Item>
                        :
                        <>
                            <Descriptions.Item label="Account Number">{record_params.account_number || "---"}</Descriptions.Item>
                            <Descriptions.Item label="IFSC Code">{record_params.ifsc || "---"}</Descriptions.Item>
                        </>
                }
            </>
        )
    };

    const renderTransactionOrders = () => {
        return (
            <>
                <Descriptions.Item label="Merchant Request Number">{record_params.unique_request_number}</Descriptions.Item>
                <Descriptions.Item label="Amount">{printRupee(record_params.amount, 2)}</Descriptions.Item>
                <Descriptions.Item label="Per Transaction Amount">{record_params.per_transaction_amount ? printRupee(record_params.per_transaction_amount, 2) : '--'}</Descriptions.Item>
                <Descriptions.Item label="Notification Cycle" >{record_params.notification_cycle_type ? SMART_COLLECT_TRANSACTION_ORDERS_NOTIFICATION_CYCLE_TYPES[record_params.notification_cycle_type].label : '--'}</Descriptions.Item>
                <Descriptions.Item label="Customer Name">{record_params.customer_name}</Descriptions.Item>
                <Descriptions.Item label="Customer Email">{record_params.customer_email ? record_params.customer_email : '--'}</Descriptions.Item>
                <Descriptions.Item label="Customer Phone">{record_params.customer_phone}</Descriptions.Item>
                <Descriptions.Item label="UDF1" >{record_params.udf1 ? record_params.udf1 : '--'}</Descriptions.Item>
                <Descriptions.Item label="UDF2" >{record_params.udf2 ? record_params.udf2 : '--'}</Descriptions.Item>
                <Descriptions.Item label="UDF3" >{record_params.udf3 ? record_params.udf3 : '--'}</Descriptions.Item>
                <Descriptions.Item label="UDF4" >{record_params.udf4 ? record_params.udf4 : '--'}</Descriptions.Item>
                <Descriptions.Item label="UDF5" >{record_params.udf5 ? record_params.udf5 : '--'}</Descriptions.Item>
            </>
        )
    };

    const renderVendorRecord = () => {
        return (
            <>
                <Descriptions.Item label="Vendor Name">{record_params.name}</Descriptions.Item>
                <Descriptions.Item label="Vendor Email">{record_params.email ? record_params.email : '--'}</Descriptions.Item>
                <Descriptions.Item label="Vendor Phone">{record_params.phone}</Descriptions.Item>
                <Descriptions.Item label="Account Name">{record_params.name_on_bank || "---"}</Descriptions.Item>
                <Descriptions.Item label="Account Number">{record_params.account_number || "---"}</Descriptions.Item>
                <Descriptions.Item label="IFSC">{record_params.account_ifsc || "---"}</Descriptions.Item>

            </>
        )
    };

    const renderVendorInvoiceRecord = () => {
        return (
            <>
                <Descriptions.Item label="Invoice Number"> {record_params.invoice_number}</Descriptions.Item>
                <Descriptions.Item label="Vendor ID"> {record_params.vendor_id}</Descriptions.Item>
                <Descriptions.Item label="Description"> {record_params.description || "---"}</Descriptions.Item>
                <Descriptions.Item label="Account Number"> {record_params.account_number}</Descriptions.Item>
                <Descriptions.Item label="Invoice Date">{record_params.invoice_date ? moment(record_params.invoice_date).format("LL") : "---"}</Descriptions.Item>
                <Descriptions.Item label="Due Date"> {record_params.due_date ? moment(record_params.due_date).format("LL") : "---"}</Descriptions.Item>
                <Descriptions.Item label="Payment Mode"> {record_params.payment_mode || '---'}</Descriptions.Item>
                <Descriptions.Item label="Gross Amount">  {printRupee(record_params.gross_amount)}</Descriptions.Item>
                <Descriptions.Item label="GST Amount"> {record_params.gst_amount && printRupee(record_params.gst_amount) || '---'}</Descriptions.Item>
                <Descriptions.Item label="TDS Percentage"> {record_params.tds_percentage && `${record_params.tds_percentage} %` || '---'}</Descriptions.Item>
                <Descriptions.Item label="Total Amount"> {record_params.total_amount && printRupee(record_params.total_amount) || '---'}</Descriptions.Item>
                {record_params.invoice_status ?
                    <Descriptions.Item label="Invoice Status"> {<Badge
                        color={VENDOR_INVOICE_STATUS_TYPES[record_params.invoice_status].color}
                        text={<Text4>{VENDOR_INVOICE_STATUS_TYPES[record_params.invoice_status].label}</Text4>}
                    />}</Descriptions.Item>
                    : null}
            </>
        )
    };

    const renderPennyDropRecord = () => {
        return (
            <>
                <Descriptions.Item label="Account Number">{record_params && record_params.account_no || "---"}</Descriptions.Item>
                <Descriptions.Item label="IFSC Code">{record_params && record_params.ifsc || "---"}</Descriptions.Item>
                <Descriptions.Item label="Account Validity">{!isEmpty(record_response) ? (record_response.data?.status=="valid" ? "Valid Account details" : "Invalid account details") : "Account validation pending"}</Descriptions.Item>
                <Descriptions.Item label="Account Holder Name">{!isEmpty(record_response) ? record_response.data?.account_holder_name || "---" : "Account validation pending"}</Descriptions.Item>
            </>
        )
    }
   
    const renderAdvancedPennyDropRecord = () => {
        return (
            <>
                <Descriptions.Item label="Account Number">{record_params && record_params.account_no || "---"}</Descriptions.Item>
                <Descriptions.Item label="IFSC Code">{record_params && record_params.ifsc || "---"}</Descriptions.Item>
                <Descriptions.Item label={renderAccountHolderNamewithTooltip()}>{record_params && record_params.account_holder_name || "---"}</Descriptions.Item>
                <Descriptions.Item label="Percentage Match Threshold">{record_params && record_params.threshold_percentage || "---"}</Descriptions.Item>
                <Descriptions.Item label="Account Validity">{!isEmpty(record_response) ? (record_response.data?.status=="valid" ? "Valid Account details" : "Invalid account details") : "Account validation pending"}</Descriptions.Item>
                <Descriptions.Item label="Comparison Percentage">{!isEmpty(record_response) ? record_response.data?.percentage_match || "---" : "Account validation pending"}</Descriptions.Item>
                <Descriptions.Item label={renderComparisonValiditywithTooltip()}>
                {!isEmpty(record_response) ? record_response.data &&
                    <Badge color={COMPARISON_VALIDITY_STATUS[record_response.data?.is_matched]?.color}
                        text={<Text4> {COMPARISON_VALIDITY_STATUS[record_response.data?.is_matched]?.label} </Text4>}/> || "---" :
                    "Account validation pending"
                }
                </Descriptions.Item>
                <Descriptions.Item label={renderBankAccountHolderNamewithTooltip()}>{!isEmpty(record_response) ? record_response.data?.account_holder_name || "---" : "Account validation pending"}</Descriptions.Item>
            </>
        )
    }

    const getPaymentMode=(arr)=>{
        let paymentModes=[]
        if(arr.includes('upi')){
            paymentModes.push('Upi')
        }
        if(arr.includes('bank_account')){
            paymentModes.push('Bank Account') 
        }

        return paymentModes.length>0? paymentModes.join(',') : null
    }

    const renderPayoutLinkRecord = () => {
        return (
            <>
                <Descriptions.Item label="Payee Name">{ record_params?.payee_name || "---"}</Descriptions.Item>
                <Descriptions.Item label="Phone Number">{ record_params?.payee_phone || "---"}</Descriptions.Item>
                <Descriptions.Item label="Payee Email">{ record_params?.payee_email || "---"}</Descriptions.Item>
                <Descriptions.Item label="Amount">{ record_params?.amount || "---"}</Descriptions.Item>
                <Descriptions.Item label="Mode">{getPaymentMode(record_params?.allowed_beneficiary_types) }</Descriptions.Item>
                <Descriptions.Item label="Unique Code">{record_params?.unique_code || '---'}</Descriptions.Item>
                <Descriptions.Item label="Expiry Date">{record_params?.expiry_date || '---'}</Descriptions.Item>
                <Descriptions.Item label="Description">{record_params?.description || '---'}</Descriptions.Item>
            </>
        )
    }

    const renderDescriptions = () => {
        console.log(batch_record)
        if (batch_record.batch_type == "transfer") {
            return renderTransferDescriptions();
        }
        else if (batch_record.batch_type == "beneficiary") {
            return renderBeneficiaryDescriptions();
        }
        else if (batch_record.batch_type == "instacollect_order") {
            return renderTransactionOrders();
        }
        else if (batch_record.batch_type == "vendor") {
            return renderVendorRecord();
        }
        else if (batch_record.batch_type == "vendor_invoice") {
            return renderVendorInvoiceRecord();
        }
        else if (batch_record.batch_type == "penny_drop") {
            return renderPennyDropRecord();
        }
        else if (batch_record.batch_type == "advanced_penny_drop") {
            return renderAdvancedPennyDropRecord();
        }
        else if (batch_record.batch_type == "payout_link") {
            return renderPayoutLinkRecord();
        }
    };

    const renderDetails = () => {
        return (
            <Descriptions className="mb-4" column={1} size="small" bordered>
                {renderDescriptions()}
            </Descriptions>
        )
    };

    const renderFailure = () => {
        let error_message = "";
        if (batch_record.batch_type == "transfer" && ["failure", "rejected"].includes(record.status)) {
            error_message = record.failure_reason
        }
        else if (batch_record.status == "failed") {
            error_message = record_response.message || record_response.error || "Something went wrong."
        }
        return (
            error_message ?
                <>
                    <Text4 type="danger">Failure Reason: </Text4>
                    <Text4>{error_message}</Text4>
                </> : null
        )
    };

    return (
        <EaseDrawer
            title={false}
            width={450}
            visible={props.visible}
            onClose={props.toggleRecordDetailsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {renderDetails()}
                {renderAdditionalDetails()}
                {renderFailure()}
            </div>
        </EaseDrawer>
    )
};

export { RecordDetailsDrawer };